/**
 * Created by Arif Topcu in 2019
 */

import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import Combobox from '@ls/react-combobox-grid';
import {useSelector} from 'react-redux';
import {calcTypeOptions} from 'state/Constants/CalcType';
import {scaleTypeOptions} from 'state/Constants/ScaleType';
import {
  selectFetchingPeriods,
  selectFetchingTypes,
  selectPeriods,
  selectTypes,
} from 'state/factorAttribution/selectors';
import {Cell, Grid} from "styled-css-grid";

const FactorAttributionSelectorComplication = ({setDefinition, definition}) => {
  const fetchingTypes = useSelector(selectFetchingTypes);
  const types = useSelector(selectTypes);
  const fetchingPeriods = useSelector(selectFetchingPeriods);
  const periods = useSelector(selectPeriods);

  const typeOptions = useMemo(
    () => types.map(val => ({label: val, value: val})),
    [types]
  );

  const periodOptions = useMemo(
    () => periods.map(val => ({label: val, value: val})),
    [periods]
  );

  const [setFactorType, setScaleType, setCalcType, setPeriod] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setFactorType(value)),
      (value) => setDefinition(definition.setScaleType(value)),
      (value) => setDefinition(definition.setCalcType(value)),
      (value) => setDefinition(definition.setPeriod(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={9} gap="4px">
      <Cell width={3}>
        <Combobox
          label="Factor:"
          value={definition.factorType}
          loading={fetchingTypes}
          options={typeOptions}
          onChange={setFactorType}
          gridHeight={200}
          size="S"
          variation={0}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={scaleTypeOptions}
          onChange={setScaleType}
          value={definition.scaleType}
          label="Type:"
          clearable={false}
          variation={0}
          size={'S'}
          gridHeight={120}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          label="Calc:"
          value={definition.calcType}
          options={calcTypeOptions}
          onChange={setCalcType}
          gridHeight={120}
          size={'S'}
          variation={0}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          label="Period:"
          value={definition.period}
          loading={fetchingPeriods}
          options={periodOptions}
          onChange={setPeriod}
          gridHeight={200}
          size="S"
          variation={0}
        />
      </Cell>
      {/*<Cell width={6}>*/}
      {/*  <Combobox*/}
      {/*    label="To Date:"*/}
      {/*    tooltip={"Leave empty for default date."}*/}
      {/*    placeholder={`Default date (${asOfDate})`}*/}
      {/*    options={asOfDateOptions}*/}
      {/*    value={definition.asOfDate}*/}
      {/*    onChange={setAsOfDate}*/}
      {/*    gridHeight={200}*/}
      {/*    size="S"*/}
      {/*    variation={0}*/}
      {/*  />*/}
      {/*</Cell>*/}
    </Grid>
  );
};

FactorAttributionSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(FactorAttributionSelectorComplication);
